/**
 * Stay AI frequency cards — Mixers-style 30/60/90 “Deliver every” cards.
 * Replaces the native frequency <select> inside product-selling-plan when enabled.
 */
(function () {
  'use strict';

  var ROOT_SEL = 'product-selling-plan[data-stay-freq-cards="true"], product-selling-plan[data-stay-freq-native="true"]';

  /** 14/30 days → 1, 60 days → 2, 90 days → 3 */
  function quantityFromInterval(raw) {
    var text = String(raw || '').replace(/\s+/g, ' ').trim().toLowerCase();
    if (!text) return 1;
    if (/\b90\b/.test(text) || /3\s*months?/.test(text)) return 3;
    if (/\b60\b/.test(text) || /2\s*months?/.test(text)) return 2;
    if (
      /\b14\b/.test(text) ||
      /\b30\b/.test(text) ||
      /1\s*months?/.test(text) ||
      /monthly/.test(text)
    ) {
      return 1;
    }
    var days = text.match(/(\d+)\s*days?/);
    if (days) {
      var d = parseInt(days[1], 10);
      if (d >= 75) return 3;
      if (d >= 45) return 2;
      return 1;
    }
    var months = text.match(/(\d+)\s*months?/);
    if (months) return Math.max(1, Math.min(parseInt(months[1], 10), 6));
    return 1;
  }

  function toDaysLabel(raw) {
    var text = String(raw || '').replace(/\s+/g, ' ').trim();
    if (!text) return null;

    var bottles = quantityFromInterval(text);
    var m = text.match(/(\d+)\s*months?/i);
    if (m) {
      return {
        days: String(parseInt(m[1], 10) * 30),
        unit: 'days supply',
        bottles: bottles
      };
    }
    m = text.match(/(\d+)\s*weeks?/i);
    if (m) {
      return {
        days: String(parseInt(m[1], 10) * 7),
        unit: 'days supply',
        bottles: bottles
      };
    }
    m = text.match(/(\d+)\s*days?/i);
    if (m) {
      return {
        days: String(m[1]),
        unit: 'days supply',
        bottles: bottles
      };
    }
    m = text.match(/^(\d+)$/);
    if (m) {
      return {
        days: String(m[1]),
        unit: 'days supply',
        bottles: bottles
      };
    }
    return null;
  }

  function getProductScope(host) {
    return (
      (host instanceof HTMLElement &&
        (host.closest('product-main') ||
          host.closest('.main-product-info') ||
          host.closest('.product-info-inner') ||
          host.closest('[data-product-root]') ||
          host.closest('product-info'))) ||
      document
    );
  }

  function setFormQuantity(host, qty) {
    var n = String(Math.max(1, parseInt(qty, 10) || 1));
    var scope = getProductScope(host);

    var select = scope.querySelector('select.qnty_cstm, select.product-select_quantity');
    if (select) {
      var hasOption = false;
      var i = 0;
      for (i = 0; i < select.options.length; i++) {
        if (String(select.options[i].value) === n) {
          hasOption = true;
          break;
        }
      }
      if (!hasOption) {
        var opt = document.createElement('option');
        opt.value = n;
        opt.textContent = n;
        select.appendChild(opt);
      }
      select.value = n;
      try {
        select.dispatchEvent(new Event('change', { bubbles: true }));
      } catch (e) {
        void e;
      }
    }

    var inputs = scope.querySelectorAll(
      'input.quantity-input, input.qnty_cstm_org, input[name="quantity"], quantity-input input[name="quantity"]'
    );
    inputs.forEach(function (input) {
      if (input.closest('.cart-items') || input.closest('#side-cart') || input.closest('#cart')) return;
      input.value = n;
      try {
        input.setAttribute('value', n);
        input.dispatchEvent(new Event('change', { bubbles: true }));
        input.dispatchEvent(new Event('input', { bubbles: true }));
      } catch (e2) {
        void e2;
      }
    });
  }

  function syncQuantityForPlan(host, planId) {
    if (!isSubscriptionSelected(host)) return;
    var qty = 1;
    var mount = host.querySelector('[data-stay-freq-root]');
    var active =
      (mount &&
        mount.querySelector('.stay-freq-opt[data-plan-id="' + String(planId || '') + '"]')) ||
      (mount && mount.querySelector('.stay-freq-opt.is-active'));
    if (active) {
      var fromCard = parseInt(active.getAttribute('data-qty'), 10);
      if (fromCard > 0) qty = fromCard;
    } else {
      var select = findFrequencySelect(host);
      if (select && select.options) {
        var i = 0;
        for (i = 0; i < select.options.length; i++) {
          if (planId && String(select.options[i].value) !== String(planId)) continue;
          qty = quantityFromInterval(select.options[i].textContent);
          break;
        }
      }
    }
    setFormQuantity(host, qty);
  }

  function badgeForBottles(bottles) {
    if (bottles === 1) return { text: 'Wise Choice', best: false };
    if (bottles === 2) return { text: 'Most Popular', best: false };
    if (bottles >= 3) return { text: 'Best Value', best: false };
    return null;
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  function resizeImageUrl(src, size) {
    if (!src) return '';
    size = size || '120x';
    if (window.$s && typeof window.$s.imgUrlFilter === 'function') {
      try {
        return window.$s.imgUrlFilter(src, size);
      } catch (e) {
        void e;
      }
    }
    var parts = String(src).split('?');
    var path = parts[0];
    var qs = parts[1] ? '?' + parts[1] : '';
    var dot = path.lastIndexOf('.');
    if (dot < 0) return src;
    return path.substring(0, dot) + '_' + size + path.substring(dot) + qs;
  }

  function srcFromMedia(media) {
    if (!media) return '';
    if (media.src) return media.src;
    if (media.preview_image && media.preview_image.src) return media.preview_image.src;
    return '';
  }

  function getCurrentVariant(scope) {
    if (!scope) return null;
    if (scope.variantsElement && typeof scope.variantsElement.getCurrentVariant === 'function') {
      return scope.variantsElement.getCurrentVariant() || null;
    }
    var data = scope.productData;
    if (!data || !Array.isArray(data.variants)) return null;
    var input = scope.querySelector('input[name="id"], select[name="id"]');
    if (!input || !input.value) return null;
    var i = 0;
    for (i = 0; i < data.variants.length; i++) {
      if (String(data.variants[i].id) === String(input.value)) return data.variants[i];
    }
    return null;
  }

  function mediaMatchesVariant(media, variant, options) {
    if (!media || !media.alt) return true;
    var show = true;
    String(media.alt)
      .split(';')
      .forEach(function (raw) {
        if (!show) return;
        var f = String(raw || '').trim();
        if (!f) return;
        var parts = f.split(':');
        if (parts.length < 2) return;
        var key = parts[0].trim();
        var values = parts.slice(1).join(':').trim();
        var optionIndex = -1;
        var i = 0;
        for (i = 0; i < (options || []).length; i++) {
          if (String(options[i]).toLowerCase() === key.toLowerCase()) {
            optionIndex = i;
            break;
          }
        }
        if (optionIndex < 0 || !values || !variant || !variant.options) return;
        var found = false;
        values.split(',').forEach(function (value) {
          var trimmed = value.trim();
          var optVal = variant.options[optionIndex];
          if (optVal === trimmed || String(optVal || '').toLowerCase() === trimmed.toLowerCase()) {
            found = true;
          }
        });
        show = found;
      });
    return show;
  }

  function imageUrlFromVariant(scope, variant) {
    if (!variant) return '';

    if (variant.featured_image && variant.featured_image.src) {
      return resizeImageUrl(variant.featured_image.src, '120x');
    }
    var featuredSrc = srcFromMedia(variant.featured_media);
    if (featuredSrc) return resizeImageUrl(featuredSrc, '120x');

    var data = scope && scope.productData;
    var mediaList = data && data.media;
    var options = (data && data.options) || [];
    if (!Array.isArray(mediaList)) return '';

    var firstMatch = '';
    var flavorSrc = '';
    var i = 0;
    for (i = 0; i < mediaList.length; i++) {
      var media = mediaList[i];
      if (!mediaMatchesVariant(media, variant, options)) continue;
      var src = srcFromMedia(media);
      if (!src) continue;
      if (!firstMatch) firstMatch = src;
      if (media.alt && /flavou?r\s*:/i.test(media.alt)) {
        flavorSrc = src;
        break;
      }
    }
    var picked = flavorSrc || firstMatch;
    return picked ? resizeImageUrl(picked, '120x') : '';
  }

  function getUnitImageUrl(host) {
    var scope = getProductScope(host);
    var variant = getCurrentVariant(scope);
    var fromVariant = imageUrlFromVariant(scope, variant);
    if (fromVariant) return fromVariant;

    var fromHost = host && (host.getAttribute('data-unit-image') || '').trim();
    if (fromHost) return fromHost;

    var qtyRoot =
      (scope && scope.querySelector && scope.querySelector('[data-pdp-qty-selectors][data-unit-image]')) ||
      document.querySelector('[data-pdp-qty-selectors][data-unit-image]');
    if (qtyRoot) {
      var fromQty = (qtyRoot.getAttribute('data-unit-image') || '').trim();
      if (fromQty) return fromQty;
    }

    var mediaRoot = scope && scope !== document ? scope : document;
    var media =
      mediaRoot.querySelector('.main-product-media img.lazyload') ||
      mediaRoot.querySelector('.main-product-media img') ||
      mediaRoot.querySelector('product-gallery img') ||
      mediaRoot.querySelector('product-main img');
    if (media && media.currentSrc) return media.currentSrc;
    if (media && media.src) return media.src;
    if (media && media.getAttribute('data-srcset')) {
      var first = String(media.getAttribute('data-srcset')).split(',')[0] || '';
      return first.trim().split(/\s+/)[0] || '';
    }
    return '';
  }

  function applyBottleImages(host, url) {
    if (!url) return;
    var mount = host && host.querySelector && host.querySelector('[data-stay-freq-root]');
    if (!mount) return;
    mount.querySelectorAll('img.stay-freq-opt__bottle').forEach(function (img) {
      if (img.getAttribute('src') !== url) img.setAttribute('src', url);
    });
  }

  function formatSavePill(raw) {
    var text = String(raw || '').replace(/\s+/g, ' ').trim();
    if (!text) return '';
    var pct = text.match(/(\d+(?:\.\d+)?)\s*%/);
    if (pct) return 'Save ' + Math.round(parseFloat(pct[1])) + '%';
    if (/^save\b/i.test(text)) return text.replace(/^save/i, 'Save');
    return text;
  }

  function getSaveLabel(host) {
    var override = (host.getAttribute('data-stay-freq-save') || '').trim();
    if (override) return formatSavePill(override);

    var disc = host.querySelector('.subscription .option-discount');
    var pct = disc && String(disc.textContent || '').match(/(\d+(?:\.\d+)?)\s*%/);
    if (pct) return 'Save ' + Math.round(parseFloat(pct[1])) + '%';
    return '';
  }

  function getPlanSaveLabel(host, planId, bottles, fallback) {
    var groups = host && host.sellingPlanGroups;
    if (Array.isArray(groups)) {
      var g = 0;
      var p = 0;
      var plans;
      var adj;
      for (g = 0; g < groups.length; g++) {
        plans = groups[g] && groups[g].selling_plans;
        if (!plans) continue;
        for (p = 0; p < plans.length; p++) {
          if (String(plans[p].id) !== String(planId)) continue;
          adj = plans[p].price_adjustments && plans[p].price_adjustments[0];
          if (adj && adj.value) return 'Save ' + Math.round(parseFloat(adj.value)) + '%';
        }
      }
    }

    var qtyRoot = document.querySelector('[data-pdp-qty-selectors]');
    if (qtyRoot && bottles) {
      var card = qtyRoot.querySelector('.pdp-qty-opt[data-qty="' + String(bottles) + '"] .pdp-qty-opt__save');
      var fromQty = card && String(card.textContent || '').trim();
      if (fromQty) return formatSavePill(fromQty);
    }

    return fallback || '';
  }

  function findFrequencySelect(host) {
    return (
      host.querySelector('.standardSubscription select.enabled') ||
      host.querySelector('[data-plans] select.enabled') ||
      host.querySelector('.standardSubscription select:not(.prepaidPlans)') ||
      host.querySelector('[data-plans] select:not(.prepaidPlans)') ||
      host.querySelector('.subscription select:not(.prepaidPlans)')
    );
  }

  function isSubscriptionSelected(host) {
    var checked = host.querySelector('[name="purchase_option"]:checked');
    if (!checked) {
      var plan = host.querySelector('input[name="selling_plan"]');
      return Boolean(plan && String(plan.value || '').trim());
    }
    if (checked.closest('.one-time')) return false;
    if (checked.closest('.subscription')) return true;
    var val = String(checked.value || '').trim();
    return val !== '' && val !== 'onetime';
  }

  function buildBottlesHtml(count, imageUrl) {
    var n = Math.max(1, Math.min(parseInt(count, 10) || 1, 6));
    var html = '<span class="stay-freq-opt__bottles" aria-hidden="true">';
    var i = 0;
    for (i = 0; i < n; i++) {
      if (imageUrl) {
        html +=
          '<img class="stay-freq-opt__bottle" src="' +
          escapeHtml(imageUrl) +
          '" alt="" width="40" height="78" loading="lazy">';
      } else {
        html += '<span class="stay-freq-opt__bottle stay-freq-opt__bottle--placeholder"></span>';
      }
    }
    html += '</span>';
    return html;
  }

  function placeMount(mount, host, select) {
    var subscription = host.querySelector('.subscription');
    var std =
      (subscription && subscription.querySelector('.standardSubscription')) ||
      (select && select.closest('.standardSubscription')) ||
      null;

    // Keep cards under benefits / above prepaid, but stop label from stealing clicks
    // by handling events in capture + calling updateSellingPlan directly.
    if (std && std.parentElement) {
      var parent = std.parentElement;
      if (mount.parentElement !== parent || std.nextSibling !== mount) {
        parent.insertBefore(mount, std.nextSibling);
      }
      return;
    }

    if (subscription) {
      var label = subscription.querySelector('label.main-label, label.checkbox-custom-label');
      if (label) {
        if (label.nextSibling !== mount) {
          subscription.insertBefore(mount, label.nextSibling);
        }
        return;
      }
      if (mount.parentElement !== subscription) subscription.appendChild(mount);
      return;
    }

    if (host && mount.parentElement !== host) host.appendChild(mount);
  }

  function ensureMount(host, select) {
    var existing = host.querySelector('[data-stay-freq-root]');
    if (existing) {
      placeMount(existing, host, select);
      return existing;
    }

    var mount = document.createElement('div');
    mount.className = 'stay-freq-cards';
    mount.setAttribute('data-stay-freq-root', 'true');
    placeMount(mount, host, select);
    return mount;
  }

  function hideNativeFrequency(host, select, hide) {
    if (host.getAttribute('data-stay-freq-native') === 'true') hide = false;
    var cardsOn = host.getAttribute('data-stay-freq-cards') === 'true';
    var forceHide = cardsOn || hide;
    var dataPlans = host.querySelector('.subscription [data-plans]');
    if (dataPlans) dataPlans.classList.toggle('stay-freq-native--hidden', forceHide);

    var field = select && (select.closest('.field') || select.parentElement);
    if (field) field.classList.toggle('stay-freq-native--hidden', forceHide);

    var desc = host.querySelector('.subscription .option-description');
    if (desc) desc.classList.toggle('stay-freq-native--hidden', forceHide);
  }

  function usesNativeDropdown(host) {
    return Boolean(host && host.getAttribute('data-stay-freq-native') === 'true');
  }

  function nativeHeadingText(host) {
    return String((host && host.getAttribute('data-stay-freq-heading')) || '').trim();
  }

  function ensureNativeHeading(host) {
    if (!(host instanceof HTMLElement)) return;
    var existing = host.querySelector('[data-stay-freq-native-heading]');
    if (!usesNativeDropdown(host)) {
      if (existing) existing.remove();
      return;
    }

    var heading = nativeHeadingText(host);
    var select = findFrequencySelect(host);
    var show = Boolean(heading && select && isSubscriptionSelected(host));
    if (!show) {
      if (existing) existing.hidden = true;
      return;
    }

    var el = existing;
    if (!el) {
      el = document.createElement('span');
      el.className = 'stay-freq-native-heading';
      el.setAttribute('data-stay-freq-native-heading', '');
    }
    if (el.textContent !== heading) el.textContent = heading;
    el.hidden = false;
    el.removeAttribute('hidden');

    var plans = host.querySelector('.subscription .standardSubscription [data-plans]');
    var parent = (plans && plans.parentElement) || (select && select.parentElement);
    var before = plans || select;
    if (parent && before && el.nextElementSibling !== before) {
      parent.insertBefore(el, before);
    }
  }

  function setActiveCards(mount, planId) {
    if (!mount) return;
    var id = String(planId || '');
    mount.querySelectorAll('.stay-freq-opt').forEach(function (btn) {
      var on = String(btn.getAttribute('data-plan-id') || '') === id;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-selected', on ? 'true' : 'false');
    });
  }

  function currentPlanId(host, select) {
    if (select && select.value) return String(select.value);
    var planInput = host.querySelector('input[name="selling_plan"]');
    if (planInput && planInput.value) return String(planInput.value);
    return '';
  }

  function optionsSignature(select) {
    if (!select || !select.options) return '';
    var parts = [];
    var i = 0;
    for (i = 0; i < select.options.length; i++) {
      parts.push(String(select.options[i].value) + ':' + String(select.options[i].textContent || '').trim());
    }
    return parts.join('|');
  }

  function renderCards(host, force) {
    if (!(host instanceof HTMLElement) || host._stayFreqSelecting) return;
    var select = findFrequencySelect(host);
    var subSelected = isSubscriptionSelected(host);

    if (usesNativeDropdown(host)) {
      hideNativeFrequency(host, select, false);
      var cardsMount = host.querySelector('[data-stay-freq-root]');
      if (cardsMount) {
        cardsMount.hidden = true;
        cardsMount.innerHTML = '';
        cardsMount._stayFreqSig = '';
      }
      ensureNativeHeading(host);
      return;
    }

    var mount = host.querySelector('[data-stay-freq-root]');

    if (!select || !select.options || select.options.length < 1) {
      // Variant rebuilds wipe [data-plans] before options are restored.
      // Don't hide existing cards; retry a few times until plans are back.
      if (subSelected) {
        host._stayFreqMissingSelectTries = (host._stayFreqMissingSelectTries || 0) + 1;
        if (host._stayFreqMissingSelectTries < 8) scheduleRender(host);
      }
      return;
    }
    host._stayFreqMissingSelectTries = 0;

    mount = ensureMount(host, select);
    hideNativeFrequency(host, select, subSelected);

    if (!subSelected) {
      mount.hidden = true;
      mount.innerHTML = '';
      mount._stayFreqSig = '';
      return;
    }

    mount.hidden = false;
    var selectedValue = currentPlanId(host, select);
    var imageUrl = getUnitImageUrl(host);
    var sig = optionsSignature(select) + '::' + selectedValue + '::' + getSaveLabel(host) + '::' + imageUrl;

    // Avoid wiping DOM (and losing clicks) when nothing meaningful changed.
    if (!force && mount._stayFreqSig === sig && mount.querySelector('.stay-freq-opt')) {
      setActiveCards(mount, selectedValue);
      applyBottleImages(host, imageUrl);
      return;
    }
    mount._stayFreqSig = sig;

    var heading = (host.getAttribute('data-stay-freq-heading') || 'Delivery frequency').trim();
    var fallbackSave = getSaveLabel(host);

    var cardsHtml = '';
    var i = 0;
    var firstValue = '';
    for (i = 0; i < select.options.length; i++) {
      var opt = select.options[i];
      var value = String(opt.value || '');
      if (!value) continue;
      if (!firstValue) firstValue = value;

      var parsed = toDaysLabel(opt.textContent) || {
        days: String(i + 1),
        unit: 'days supply',
        bottles: i + 1
      };
      var badge = badgeForBottles(parsed.bottles);
      var saveLabel = getPlanSaveLabel(host, value, parsed.bottles, fallbackSave);
      var active = value === selectedValue || (!selectedValue && value === firstValue);

      cardsHtml +=
        '<div class="stay-freq-opt' +
        (active ? ' is-active' : '') +
        '" role="option" tabindex="0" aria-selected="' +
        (active ? 'true' : 'false') +
        '" data-plan-id="' +
        escapeHtml(value) +
        '" data-qty="' +
        escapeHtml(String(parsed.bottles)) +
        '">';

      if (badge) {
        cardsHtml +=
          '<span class="stay-freq-opt__badge' +
          (badge.best ? ' stay-freq-opt__badge--best' : '') +
          '">' +
          escapeHtml(badge.text) +
          '</span>';
      }

      cardsHtml += buildBottlesHtml(parsed.bottles, imageUrl);
      cardsHtml += '<span class="stay-freq-opt__days">' + escapeHtml(parsed.days) + '</span>';
      cardsHtml += '<span class="stay-freq-opt__unit">' + escapeHtml(parsed.unit) + '</span>';
      if (saveLabel) {
        cardsHtml += '<span class="stay-freq-opt__save">' + escapeHtml(saveLabel) + '</span>';
      }
      cardsHtml += '</div>';
    }

    mount.innerHTML =
      '<div class="stay-freq-cards__grid" role="listbox" aria-label="' +
      escapeHtml(heading) +
      '">' +
      cardsHtml +
      '</div>';

    syncQuantityForPlan(host, selectedValue || firstValue);
  }

  function selectPlan(host, planId) {
    planId = String(planId || '');
    if (!planId) return;

    host._stayFreqSelecting = true;

    var select = findFrequencySelect(host);
    if (select) {
      var hasOpt = false;
      var i = 0;
      for (i = 0; i < select.options.length; i++) {
        if (String(select.options[i].value) === planId) {
          hasOpt = true;
          break;
        }
      }
      if (hasOpt) select.value = planId;
    }

    // Stay AI source of truth — call the custom element API when available.
    if (typeof host.updateSellingPlan === 'function') {
      host.updateSellingPlan(planId);
    } else {
      var planInput = host.querySelector('input[name="selling_plan"]');
      if (planInput) {
        planInput.value = planId;
        try {
          planInput.dispatchEvent(new Event('change', { bubbles: true }));
        } catch (e) {
          void e;
        }
      }
    }

    // Also notify the native select listeners Stay AI attached.
    if (select) {
      try {
        select.dispatchEvent(new Event('change', { bubbles: true }));
      } catch (e2) {
        void e2;
      }
    }

    var mount = host.querySelector('[data-stay-freq-root]');
    setActiveCards(mount, planId);
    if (mount) mount._stayFreqSig = optionsSignature(select) + '::' + planId + '::' + getSaveLabel(host);
    syncQuantityForPlan(host, planId);
    [80, 200, 500].forEach(function (ms) {
      window.setTimeout(function () {
        syncQuantityForPlan(host, planId);
      }, ms);
    });

    window.clearTimeout(host._stayFreqSelectUnlock);
    host._stayFreqSelectUnlock = window.setTimeout(function () {
      host._stayFreqSelecting = false;
    }, 150);
  }

  function onFreqActivate(host, e) {
    var t = e.target;
    if (!(t instanceof Element)) return;
    var btn = t.closest('.stay-freq-opt');
    if (!btn || !host.contains(btn)) return;

    // Cards live under Stay AI's <label>; stop the label from swallowing the interaction.
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();

    selectPlan(host, btn.getAttribute('data-plan-id'));
  }

  function openNativeSelectFromArrow(host, e) {
    if (!usesNativeDropdown(host) || e.button) return;
    var t = e.target;
    if (!(t instanceof Element)) return;
    var field = t.closest('[data-plans] .field');
    if (!field || !host.contains(field)) return;
    var select = field.querySelector('select');
    if (!select || t === select || select.contains(t)) return;

    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    try {
      if (typeof select.showPicker === 'function') select.showPicker();
      else select.focus();
    } catch (err) {
      select.focus();
    }
  }

  function bindHost(host) {
    if (!(host instanceof HTMLElement) || host.dataset.stayFreqInit === 'true') return;
    host.dataset.stayFreqInit = 'true';

    host.addEventListener('pointerdown', function (e) {
      onFreqActivate(host, e);
      openNativeSelectFromArrow(host, e);
    }, true);
    host.addEventListener('click', function (e) {
      onFreqActivate(host, e);
    }, true);
    host.addEventListener('keydown', function (e) {
      var t = e.target;
      if (!(t instanceof Element)) return;
      var btn = t.closest('.stay-freq-opt');
      if (!btn || !host.contains(btn)) return;
      if (e.key !== 'Enter' && e.key !== ' ') return;
      e.preventDefault();
      e.stopPropagation();
      selectPlan(host, btn.getAttribute('data-plan-id'));
    }, true);

    host.addEventListener(
      'change',
      function (e) {
        var t = e.target;
        if (!t) return;
        if (host._stayFreqSelecting) return;
        if (
          (t.name &&
            (t.name === 'purchase_option' ||
              t.name === 'selling_plan' ||
              t.name === 'prepaid_purchase_option')) ||
          t.tagName === 'SELECT'
        ) {
          scheduleRender(host);
        }
      },
      true
    );

    var scope = getProductScope(host);
    if (scope && scope !== document && !scope._stayFreqVariantBound) {
      scope._stayFreqVariantBound = true;
      scope.addEventListener('variantChange', function () {
        var update = function () {
          scope.querySelectorAll(ROOT_SEL).forEach(function (h) {
            renderCards(h);
            applyBottleImages(h, getUnitImageUrl(h));
          });
        };
        update();
        window.setTimeout(update, 80);
        window.setTimeout(update, 250);
      });
    }

    var observer = new MutationObserver(function () {
      if (host._stayFreqSelecting) return;
      scheduleRender(host);
    });
    observer.observe(host, { childList: true, subtree: true });

    renderCards(host, true);
    [200, 600, 1200, 2500].forEach(function (ms) {
      window.setTimeout(function () {
        renderCards(host);
      }, ms);
    });
  }

  function scheduleRender(host) {
    window.clearTimeout(host._stayFreqTimer);
    host._stayFreqTimer = window.setTimeout(function () {
      renderCards(host);
    }, 80);
  }

  function boot(scope) {
    var root = scope || document;
    root.querySelectorAll(ROOT_SEL).forEach(bindHost);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
